var render = function render(){var _vm=this,_c=_vm._self._c;return _c("detail",{tag:"div"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('SkeletonLoader')],1),_c('div',_vm._l((_vm.categories),function(category,key){return _c('Items',{key:key,attrs:{"id":"viewMore","category":category,"categoryID":key}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }